import { render, staticRenderFns } from "./CalculadoraSolar.vue?vue&type=template&id=536f050b"
import script from "./CalculadoraSolar.vue?vue&type=script&lang=js"
export * from "./CalculadoraSolar.vue?vue&type=script&lang=js"
import style0 from "./CalculadoraSolar.vue?vue&type=style&index=0&id=536f050b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports